import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Input, Spin } from 'antd';
import { DebounceInput } from 'react-debounce-input';
import Datetime from 'react-datetime';

import { useOnClickOutside } from 'hooks/';
import { toTitleCase } from 'utils/helpers';

import { DownCaret, SearchIcon } from 'assets/svgs';

import 'react-datetime/css/react-datetime.css';
import './index.scss';

export default function DatePicker({ selectedDate, setSelectedDate }) {
  const [showDate, setShowDate] = useState(false);
  const handleDate = (date) => {
    const { _d } = date;
    setSelectedDate(new Date(_d).getFullYear());
    setShowDate(!showDate);
  };

  const dateRef = useRef(null);
  useOnClickOutside(dateRef, () => setShowDate(false));

  return (
    <>
      <div className='date-picker' ref={dateRef}>
        <div
          className='date-picker__header'
          onClick={() => setShowDate(!showDate)}
        >
          <span>{selectedDate}</span>
          <DownCaret />
        </div>
        <Datetime
          open={showDate}
          dateFormat='YYYY'
          renderInput={() => {}}
          onChange={handleDate}
        />
      </div>
    </>
  );
}

export const OtherSelect = ({
  mdas,
  nameOfSelectedMda,
  handleSearchMdas,
  searchingMdas,
  setSelectedMda,
  title,
}) => {
  const [showDropDown, setShowDropDown] = useState(false);
  const classess = useStyles();

  const dropDownRef = useRef(null);

  useOnClickOutside(dropDownRef, () => {
    setShowDropDown(false);
  });

  const renderInputItem = (props) => (
    <Input
      placeholder='Search MDAs'
      {...props}
      autoFocus
      prefix={<SearchIcon />}
    />
  );

  return (
    <div className='sidebar-item'>
      <h1>{title}</h1>
      <div ref={dropDownRef}>
        <div
          className='date-picker d-flex justify-content-between align-items-center'
          onClick={() => setShowDropDown(!showDropDown)}
          style={{ position: 'relative' }}
        >
          <div className='date-picker__header'>
            <span>{nameOfSelectedMda.replace('↵', ' ')}</span>
          </div>
          <DownCaret />
        </div>
        <div
          style={{
            background: 'white',
            boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.15)',
            height: 'auto',
            position: 'absolute',
            width: 'auto',
            zIndex: 343,
            display: showDropDown ? 'block' : 'none',
            //top: '250px',
            //left: '250px',
          }}
        >
          <div className='drop-down-23'>
            <DebounceInput
              debounceTimeout={300}
              element={renderInputItem}
              onChange={handleSearchMdas}
            />
          </div>
          <div className={classess.dropDownWrapper}>
            {searchingMdas ? (
              <div
                style={{
                  height: '200px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Spin spinning={true}>
                  <div style={{ width: '396px', maxWidth: '100%' }}>
                    <p>Searching...</p>
                  </div>
                </Spin>
              </div>
            ) : mdas.length > 0 ? (
              mdas?.map(({ code, name, description, id }) => (
                <p
                  onClick={() => {
                    setSelectedMda(code, name || description, id);
                    setShowDropDown(false);
                  }}
                  key={id}
                  style={{ fontSize: '14px' }}
                >
                  {toTitleCase(name || description)}
                </p>
              ))
            ) : (
              <div
                className={classess.notFound}
                style={{ width: '396px', height: '250px', maxWidth: '100%' }}
              >
                <p style={{ fontSize: '14px' }}>Not found</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  dropDownWrapper: {
    height: '100px',
    overflowY: 'scroll',
    '& p': {
      cursor: 'pointer',
      padding: '5px 10px',
      marginBottom: '0',
      marginTop: '0',
      '&:hover': {
        background: '#f2f2f4',
      },
    },
  },
  notFound: {
    display: 'flex',
    justifyContent: 'center',
    '& p': {
      '&:hover': {
        background: 'white',
      },
    },
  },
});
